import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KMX_PHONE_BP } from '../../utils/constants';

const CUSTOM_MOBILE_INTERMEDIATE_BP = 376;

interface ILineBreakProps {
    defaultDisplay: 'initial' | 'none';
    breakpointDisplay: 'initial' | 'none';
}

const LineBreak = ({ defaultDisplay, breakpointDisplay }: ILineBreakProps) => (
    <Box
        component="br"
        sx={(theme) => ({
            display: defaultDisplay,
            [theme.breakpoints.up(CUSTOM_MOBILE_INTERMEDIATE_BP)]: { display: breakpointDisplay },
        })}
    />
);

const HeroHeading = () => (
    <Box
        className="buying-online-hero--heading-container"
        sx={(theme) => ({
            marginBottom: { xs: '-1rem', sm: '-1.5rem', md: '-11.5rem', lg: 0 },
            marginRight: { lg: '-47.5rem' },
            width: { xs: '100%', lg: '47.5rem' },
            height: '11.4375rem',
            [theme.breakpoints.up(KMX_PHONE_BP)]: { height: '7.625rem' },
            '&&': {
                // specificity increase hack
                height: { sm: '11.5rem', lg: '17.125rem' },
            },
            flex: { lg: '1 0 auto' },
        })}
    >
        <Box
            className="buying-online-hero--heading-fixed-container"
            sx={{
                position: 'fixed',
            }}
        >
            <Typography component="h1" sx={{ typography: { xs: 'h3', sm: 'h2', lg: 'h1' } }}>
                Find the&nbsp;
                <LineBreak defaultDisplay="initial" breakpointDisplay="none" />
                one,&nbsp;
                <LineBreak defaultDisplay="none" breakpointDisplay="initial" />
                buy&nbsp;
                <LineBreak defaultDisplay="initial" breakpointDisplay="none" />
                it online
            </Typography>
        </Box>
    </Box>
);

export default HeroHeading;
